<template>
    <rkm-modal
        smallLarge
        ref="RkmModalPermissao"
        title="Autorização do supervisor"
    >

    <rkm-form ref="Form">
        <rkm-row>
        <rkm-col>
                <rkm-form-input
                    v-model="model.login.usuario"
                    name="Usuário"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text><rkm-icon :icon="['far', 'user-circle']" /></rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-form-input
                    name="Senha"
                    type="password"
                    v-model="model.login.senha"
                >
                    <rkm-input-group-prepend slot="prepend">
                        <rkm-input-group-text><rkm-icon icon="lock" /></rkm-input-group-text>
                    </rkm-input-group-prepend>
                </rkm-form-input>
            </rkm-col>
        </rkm-row>
    </rkm-form>

       <template v-slot:footer>
            <rkm-button @click.stop="handleExit">
                Voltar
            </rkm-button>
            <rkm-button
                @click.stop="login"
                color="primary"
            >
                Autorizar
            </rkm-button>
        </template>

    </rkm-modal>
</template>

<script>

// Mixins.

import packageJSON from '/package.json'
import { mapActions } from 'vuex'
import { repository, error, stringCase } from '@/mixins'

export default {
    computed: {
        isLayoutLogin() {
            return this.form.layout == 'login'
        },
        validations() {
            return {
                login: {
                    usuario: {
                        required: true,
                        min: 3
                    },
                    senha: {
                        required: true,
                        min: 8
                    },
                },
                trocaSenha: {
                    novaSenha: {
                        required: true,
                        senha: true
                    },
                    novaSenhaConfirmation: {
                        required: true,
                        is: this.model.trocaSenha.novaSenha
                    },
                },
            }
        },
    },
    created() {
        this.form.packageJSON = packageJSON
        this.repositories.cliente = this.getConectaSusRepository('intranet.cliente')
        this.repositories.autenticacao = this.getConectaSusRepository('administracao.autenticacao')
        this.repositories.agendamento = this.getConectaSusRepository('exameLaboratorial.agendamentoExame')
    },
    data: () => ({
        item: null,
        index: null,
        form: {
            cliente: null,
            layout: 'login',
            packageJSON: null,
        },
        model: {
            login: {
                usuario: '',
                senha: ''
            },
            trocaSenha: {
                novaSenha: '',
                novaSenhaConfirmation: ''
            },
        },
        repositories: {},
    }),
    methods: {
        ...mapActions([
            'clear',
            'setCustomer',
            'setLoading',
            'unsetLoading',
        ]),
        load(customer) {
            this.setLoading()

            this.repositories.cliente.index({link: customer})
                .then(({ data }) => {
                    this.setCustomer(data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSupervisor(supervisorId) {

            this.setLoading()

            this.repositories.agendamento.getSupervisor({
                supervisor_id: supervisorId,
            })
            .then(response => {

                if(response.data.supervisores.length == 0){

                   this.showValidationNotification("Esse usuário não é supervisor.")

                   return false

                } else {

                    if(this.origem == null){

                        this.$emit('openModal', this.item, false, supervisorId)

                    } else if (this.origem == 'listagem') {

                       this.$emit('handlePermission', supervisorId, this.item, this.index)
                    } else {

                       this.$emit('saveModal', supervisorId)
                    }

                    this.$refs.RkmModalPermissao.hide()
                }
            })
            .catch(this.handleError)
            .finally(() => this.unsetLoading())
        },
        login() {

            this.setLoading()

            this.repositories.autenticacao.login(this.model.login)
                .then(({ data }) => {

                    this.getSupervisor(data.usuario.id)

                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        open(item, index) {

            if (item) {

                this.item = item
            }

            if (index) {

                this.index = index
            }

            this.$refs.RkmModalPermissao.show()
        },
        handleExit() {

            if (this.item && this.item.length == 0) {

                if(this.origem == null){

                    this.$emit('resetForm')
                } else {

                    this.$emit('handleExitSupervisor')
                }
            }

            this.$refs.RkmModalPermissao.hide()
        },
    },
    mixins: [ repository, error, stringCase ],
    props: {
        origem: { type: String, default: null },
    },
}
</script>